import { useFlag } from '@calendly/feature-check-react';
import { Fieldset, FieldError, FieldLabel, useErrorId } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { Select, Control, Options, Option } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { ENT_IT_RESCHEDULED_WORKFLOW_TRIGGER } from 'constants/feature_flags';
import { TRIGGER_TYPES, BOOKING_WHEN_MEETING_SCHEDULED, BOOKING_WHEN_MEETING_RESCHEDULED, BOOKING_WHEN_INVITEE_NO_SHOW } from './consts';
import { whenThisHappensText } from '../../../i18n';
const containerCss = "cvpp7jg";
const Container = forwardRef((props, ref) => <Fieldset ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const formFieldId = 'whenThisHappens';
const CustomSelect = ({
  value,
  options,
  onChange,
  invalid,
  error = null,
  ...props
}) => {
  const errorId = useErrorId({
    error
  });
  const selectedOption = options.find(({
    id
  }) => value === id);
  const optionsToUse = options.filter(option => option.id !== BOOKING_WHEN_MEETING_SCHEDULED);
  return <>
      <FieldLabel text={I18n.t('publisher.workflows.create.when_this_happens')} id={formFieldId} />
      <Select value={value} onChange={onChange} {...props}>
        <Control invalid={invalid} aria-labelledby={formFieldId} aria-describedby={errorId} placeholder={I18n.t('publisher.workflows.forms.select')}>
          {selectedOption && selectedOption.name}
        </Control>
        <Options>
          {optionsToUse.map(({
          id,
          name
        }) => <Option key={id} role="option" selected={value === id} name={id} value={id}>
              {name}
            </Option>)}
        </Options>
      </Select>
      <FieldError text={error} id={errorId} />
    </>;
};
export const TriggerSelect = props => {
  const workflowTriggerWhenMeetingRescheduledEnabled = useFlag(ENT_IT_RESCHEDULED_WORKFLOW_TRIGGER);

  /**
  * We want "Event is rescheduled" to go after "Event ends" (index 3) and before "Event is canceled" (index 4)
  * if the ent_it_event_rescheduled_workflow_trigger feature flag is enabled.
  *
  * When removing the  feature flag just update TRIGGER_TYPES and add the rescheduled trigger at index 4
  * and use TRIGGER_TYPES instead of calculating it
  */
  const triggerTypes = useMemo(() => {
    const result = [...TRIGGER_TYPES];
    if (workflowTriggerWhenMeetingRescheduledEnabled) {
      result.splice(4, 0, BOOKING_WHEN_MEETING_RESCHEDULED);
    }
    result.push(BOOKING_WHEN_INVITEE_NO_SHOW);
    return result;
  }, [workflowTriggerWhenMeetingRescheduledEnabled]);
  const options = triggerTypes.map(type => ({
    id: type,
    name: whenThisHappensText(type)
  }));
  return <Container>
      <CustomSelect options={options} {...props} />
    </Container>;
};

require("./trigger_select.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./trigger_select.js");